/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-2016 Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import {
    GraphQLObjectType as ObjectType,
    GraphQLString as StringType,
    GraphQLID as ID,
    GraphQLNonNull as NonNull,
} from 'graphql';


const FooterType = new ObjectType({
    name: 'FooterItem',
    description: 'Cet objet represente le footer',
    fields: () => ({
        id: {
            type: new NonNull(ID),
            description: 'Le id du footer',
            resolve: (root) => root.id
        },
        slug: {
            type: StringType,
            description: 'Le slug du footer',
            resolve: (root) => root.slug
        },
        title: {
            type: StringType,
            description: 'Le titre du footer',
            resolve: (root) => root.title.rendered
        },
        content: {
            type: StringType,
            description: 'Le content du footer',
            resolve: (root) => root.content.rendered
        },
        colonne1: {
            type: StringType,
            description: 'Le content du footer',
            resolve: (root) => root.acf.colonne_1
        },
        colonne2: {
            type: StringType,
            description: 'Le content du footer',
            resolve: (root) => root.acf.colonne_2
        },
        colonne3: {
            type: StringType,
            description: 'Le content du footer',
            resolve: (root) => root.acf.colonne_3
        },
    }),
});

export default FooterType;



// WEBPACK FOOTER //
// ./data/types/FooterType.js